export default {"src":"/_next/static/media/logo-loader.ce2a8b38.gif","height":1128,"width":1051,"blurWidth":0,"blurHeight":0};